export const REQUEST_AD_CONFIG = 'advertising/REQUEST_AD_CONFIG';
export const HANDLE_RESPONSE_AD_CONFIG =
  'advertising/HANDLE_RESPONSE_AD_CONFIG';
export const HANDLE_RESPONSE_ERROR_AD_CONFIG =
  'advertising/HANDLE_ERROR_AD_CONFIG';
export const CONTACT = 'feature/advertising/CONTACT';
